import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/account.svg',
})
export class AccountComponent {}
